export default __webpack_public_path__ + "images/ghost_3fa9cb.svg";